<template>
    <div :class="`${contentWrapper} card material-card`">
        <slot name="content"></slot>
    </div>
</template>

<style lang="scss">
.material-card {
    box-shadow: 2px 2px 4px 0 hsla(0, 0%, 64%, 0.37);
}
</style>
<script>
import { defineComponent } from "vue";

export default defineComponent({
    props: {
        contentWrapper: { type: String }
    }
});
</script>
